import { Avatar, Flex, Text } from "@instructure/ui";
import { Fragment } from "react/jsx-runtime";

interface ProgressStepperProps {
  steps: string[];
  currentStep: number;
}

const ProgressStepper = ({ steps, currentStep }: ProgressStepperProps) => {
  if (currentStep > steps.length) {
    throw new Error("currentStep exceeds the number of total steps.");
  }

  return (
    <Flex gap="small" justifyItems="center">
      {steps.map((step, index) => (
        <Fragment key={index}>
          <Flex.Item textAlign="center">
            <Avatar
              name={`${index + 1}`}
              size="small"
              hasInverseColor={currentStep >= index + 1}
              margin="0 small 0 0"
            />
            <Text>{step}</Text>
          </Flex.Item>
          {index < steps.length - 1 && (
            <Flex.Item width="5%" shouldShrink>
              <div
                style={{
                  borderBottom: "2px solid",
                  borderColor: currentStep > index + 1 ? "#0374B5" : "#e0e0e0",
                }}
              />
            </Flex.Item>
          )}
        </Fragment>
      ))}
    </Flex>
  );
};

export default ProgressStepper;
